import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateUser } from "../../api/users";

export function useUpdateUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateUser,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
      console.log("User updated successfully");
    },
    onError: (err) => {
      console.error("Error updating user:", err);
    },
  });
}

export default useUpdateUser;
